import {useQuery} from "react-query";
import {Client, DataQualityReport, FleetPackingData} from "../../autogenerate/api.generated.clients";
import {UseQueryResult} from "react-query/types/react/types";

export const useFleetPackingSummary = (filter?: string): UseQueryResult<FleetPackingData> => {
   return useQuery(['fleet-packing-summary', filter], async () => {
      const orgId = filter ? Number(filter) : null;
      return new Client().packingVent_GetPackingVentPredictions(orgId);
   }, {refetchOnWindowFocus: false}
   );
}